
import { Shield, UserCog, ClipboardList } from "lucide-react";
import { DashboardFeature } from "./types";

export const securityFeatures: DashboardFeature[] = [
  {
    icon: Shield,
    title: "Shift Schedule",
    description: "View your security shifts",
    href: "/dashboard/security/schedule",
  },
  {
    icon: UserCog,
    title: "Access Control",
    description: "Manage venue access",
    href: "/dashboard/security/access",
  },
  {
    icon: ClipboardList,
    title: "Incident Reports",
    description: "Submit security reports",
    href: "/dashboard/security/reports",
  }
];
